module.exports = __webpack_public_path__ + "static/media/php.263bcf0d.svg";